import styles from './navigation.module.less';

const NavigationList = ({ children, navigationClassName = '', listClassName = '' }) => {
    return (
        <nav className={[styles.navigation, navigationClassName].join(' ')}>
            <ul className={[styles.navigationList, listClassName].join(' ')}>{children}</ul>
        </nav>
    );
};

export default NavigationList;
